import { useEffect, useRef, useState } from "react";

export function useOnScreen<T extends Element>(rootMargin = "600px") {
  const ref = useRef<T | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const currentEl = ref.current;
    if (!currentEl) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setVisible(true);
        }
      },
      { root: null, rootMargin, threshold: 0 }
    );
    observer.observe(currentEl);

    return () => {
      observer.disconnect();
    };
  }, [ref.current, rootMargin]);

  return { ref, visible } as const;
}

